import styled from "styled-components";
import { VIEW_TYPE } from "../../../entities/Filter";

export const MixWrapperStyled = styled.div`
  width: 100%;
  .mix-wrapper {
    &__title {
      margin-bottom: 20px;
      padding-right: 20px;
      box-sizing: border-box;
    }
    &__items {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
      // grid-template-columns: auto;
      grid-gap: 1rem;
      gap: 1rem;
      @media (max-width: 768px) {
        grid-template-columns: auto;
      }
      &.view-${VIEW_TYPE.LIST} {
        display: block;
      }
    }
  }
`;
